export default "__VITE_ASSET__BN0Bu$Sk__"